export default __webpack_public_path__ + "static/media/register.31d6cfe0.svg";